var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8566 0.952258C23.9135 0.00925027 22.3846 0.00925052 21.4416 0.952259L12.9043 9.48961L4.36695 0.952286C3.42394 0.00927817 1.89502 0.00927851 0.952011 0.952286C0.00900155 1.8953 0.00900257 3.42421 0.952011 4.36722L9.48933 12.9045L0.952013 21.4419C0.00900349 22.3849 0.00900417 23.9138 0.952012 24.8568C1.89502 25.7998 3.42394 25.7998 4.36695 24.8568L12.9043 16.3195L21.4416 24.8568C22.3846 25.7998 23.9135 25.7998 24.8566 24.8568C25.7996 23.9138 25.7996 22.3849 24.8566 21.4419L16.3192 12.9045L24.8566 4.36719C25.7996 3.42419 25.7996 1.89527 24.8566 0.952258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/closeIconModal.4e842eb1cb3f8e39797d8f2404ba0ecb.svg";
export { ForwardRef as ReactComponent };